<template lang="pug">
	.upload-sky-kids(v-if="showed && Version.SelectedVersion")
		.card
			.card-header
				i.fa.fa-edit
				span Sky Kids {{(mode === 'upload') ? 'upload' : 'download'}}
			.card-body.collapse.show(v-if="state === 'idle'")
				.form-horizontal
					.form-group
						.two-setting-panel
							label.col-form-label
								span.title Game uid
								input.form-control(size="16" type="text" v-model="id")
							label.col-form-label
								span.title Update
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Flag to indicate that the package is an update to a previously submitted game.'}")
								label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" v-model="gameUpdate")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.two-setting-panel
							label.col-form-label
								span.title Supplier Id
								input.form-control(size="16" type="text" v-model="supplier")
							label.col-form-label
								span.title Type
								span
									select.custom-select.custom-select-sm(v-model="type")
										option(value="Game") Game
										option(value="Book") Book
										option(value="Music") Music
						.two-setting-panel
							label.col-form-label
								span.title Sky API version
								input.form-control(size="16" type="text" v-model.number="documentVersionNumber")
							label.col-form-label
								span.title Game version
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Provider identifier for this supplied version of the game, so that Sky and the provider can identify not just the game but which version is currently being used'}")
								input.form-control(size="16" type="text" v-model="gameVersionNumber")
						.two-setting-panel
							label.col-form-label
								span.title Sky business territory
								span
									select.custom-select.custom-select-sm(v-model="skyBusinessTerritory")
										option(value="GB") GB
										option(value="DE") DE
										option(value="IT") IT
							label.col-form-label
								span.title Territories
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Where this game can be played. E.g. For Sky GB this could be GB and IE to say it’s playable in Ireland. Valid values are GB,IE,DE,IT,AT etc. (separated by comma without a space) i.e. ISO Alpha 2 country codes. If a game has global rights just enter the value “ALL” in the array. Please note that for complete coverage of the British Isles you will need to include all of the following: GB,GG,IE,IM,JE'}")
								input.form-control(size="16" type="text" v-model="playableTerritories")
						.two-setting-panel
							label.col-form-label
								span.title Channels
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Channel ID for the provider – for game providers who also provide video this means their video and game content can be branded together. Value should be confirmed with Sky (separated by comma without a space)'}")
								input.form-control(size="16" type="text" v-model.number="associatedChannels")
							label.col-form-label
								span.title Shows
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Sky UUID (separated by comma without a space)'}")
								input.form-control(size="16" type="text" v-model="associatedShows")
						.two-setting-panel
							label.col-form-label
								span.title Age range
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '“PRESCHOOL” or “TWEEN” meaning suitable for roughly under 5 or older children respectively'}")
								span
									select.custom-select.custom-select-sm(v-model="ageRange")
										option(value="")
										option(value="PRESCHOOL") PRESCHOOL
										option(value="TWEEN") TWEEN
							label.col-form-label
								span.title Fullscreen
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Indicates if the game should be displayed full screen without the title bar'}")
								label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="fullScreen")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.two-setting-panel
							label.col-form-label.column
								div.col-form-label
									span.title Start date
										i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Dates when the game can first appear in the app and must be removed from the app'}")
									input.form-control(type="date" :value="availability.startDateTime && availability.startDateTime.toISOString().split('T')[0]" @input="availability.startDateTime = $event.target.valueAsDate")
								div.col-form-label
									span.title End date
										i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'If there is no end to the license please set the end year to 2099'}")
									input.form-control(type="date" :value="availability.endDateTime && availability.endDateTime.toISOString().split('T')[0]" @input="availability.endDateTime = $event.target.valueAsDate")
							label.col-form-label
								span.title Genres
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'List of genres. Should be specified.'}")
								span
									select.custom-select.custom-select-sm(v-model="genres" multiple)
										option(value="1") Action
										option(value="2") Art
										option(value="3") Board
										option(value="4") Brain teaser
										option(value="5") Creative
										option(value="6") Puzzles
										option(value="7") Music
										option(value="8") Dance
										option(value="9") Role play
										option(value="10") Quick play
										option(value="11") Pets
										option(value="12") Funny
										option(value="13") Racing
										option(value="14") Platform
										option(value="15") Strategy
										option(value="16") Quiz
										option(value="17") Dress-up
										option(value="18") Sport
										option(value="19") Time Challenge
										option(value="20") Sky Buddy
										option(value="21") Educational
						.two-setting-panel
							label.col-form-label
								span.title Upload to
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'FTP folder to upload'}")
								span
									select.custom-select.custom-select-sm(v-model="uploadTo")
										option(value="test") Testing
										option(value="new") Release
							label.col-form-label
								span.title File name
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Zip file name'}")
								input.form-control(size="16" type="text" v-model="fileName")
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="upload()")
							i.fa(:class="(mode === 'upload') ? 'fa-upload' : 'fa-download'")
							| &nbsp;&nbsp;{{(mode === 'upload') ? 'Upload' : 'Download'}}
						button.btn.btn-dark(type="button" v-on:click="hide()") Cancel
			.card-body.collapse.show(v-if="state === 'preparing' || state === 'release' || state === 'zipping' || state === 'uploading'")
				.processing
					.icon.fa.fa-spinner.fa-spin
					.text(v-if="state === 'preparing'") preparing...
					.text(v-if="state === 'release'") creating release...
					.text(v-if="state === 'zipping'") zipping...
					.text(v-if="state === 'uploading'") uploading...
			.card-body.collapse.show(v-if="state === 'result'")
				.result Done
				.form-horizontal
					.form-actions
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>
	import Screen 				from './../../mixins/screen'

	import { Publisher } 		from './../../services/Publisher'
	import { Creative } 			from './../../services/Creative'
	import { Version } 			from './../../services/Version'
	import { Settings } 		from './../../services/Settings'
	import { Layout } 			from './../../services/Layout'

	import NetworkList 			from './../Templates/NetworksList'

	export default {
		name: "UploadSkyKids",
		mixins: [Screen],
		screen: {
			events: {
				"Show UploadSkyKids": function() {

				},
				"Sky Kids upload Progress": function(data) {

					if (data.SkyKidsUploadCreativeId === Creative.SelectedCreative.id && data.SkyKidsUploadVersionId === Version.SelectedVersion.id) {

						this.state = data.SkyKidsUploadProgress;

						if (data.SkyKidsUploadResult) this.result = data.SkyKidsUploadResult;

						this.update();

					}

				}
			}
		},
		components: {
			NetworkList
		},
		data() {

			this.Publisher = Publisher;
			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			return {
				mode: 'upload',
				debugCode: false,
				state: 'idle', //'preparing', 'release', 'uploading', 'result'
				id: '',
				gameUpdate: false,
				supplier: '',
				type: 'Game',
				documentVersionNumber: 5.13,
				gameVersionNumber: '',
				skyBusinessTerritory: 'GB',
				playableTerritories: 'ALL',
				associatedChannels: '',
				associatedShows: '',
				ageRange: '',
				availability: {
					startDateTime: new Date(),
					endDateTime: new Date('2099-01-01T17:00:00.000Z')
				},
				genres: [10, 19],
				fullScreen: true,
				uploadTo: 'test',
				fileName: '',
				result: {}
			};

		},
		computed: {
		},
		methods: {
			collectData(event, mode, downloadOptions = {}) {

				if (!Creative.SelectedCreative) return;
				if (!Version.SelectedVersion) return;

				this.mode = mode || 'upload';
				this.debugCode = !!downloadOptions.debugCode;

				this.id = Creative.SelectedCreative.codename;
				this.supplier = Publisher.SelectedPublisher.options["SkyKids"]["SupplierId"];
				this.gameVersionNumber = Version.SelectedVersion.id;
				this.fileName = Creative.SelectedCreative.codename;

			},
			upload() {

				let options = {
					creativeId: Creative.SelectedCreative.id,
					versionId: Version.SelectedVersion.id,
					networkOptions: {
						id: this.id,
						gameUpdate: this.gameUpdate,
						supplier: this.supplier,
						type: this.type,
						documentVersionNumber: this.documentVersionNumber,
						gameVersionNumber: `${this.gameVersionNumber}`,
						skyBusinessTerritory: this.skyBusinessTerritory,
						playableTerritories: this.playableTerritories.split(','),
						associatedChannels: this.associatedChannels ? this.associatedChannels.split(',') : undefined,
						associatedShows: this.associatedShows ? this.associatedShows.split(',') : undefined,
						ageRange: this.ageRange ? this.ageRange : undefined,
						availability: {
							startDateTime: this.availability.startDateTime,
							endDateTime: this.availability.endDateTime
						},
						genres: _.map(this.genres, genre => parseInt(genre)),
						fullScreen: this.fullScreen,
						uploadTo: this.uploadTo,
						fileName: this.fileName
					}
				};

				if (this.mode === 'upload') {

					Settings.uploadToSkyKids(options);

					this.state = 'processing';

				} else {

					Creative.downloadCreative('sky-kids', options.networkOptions, {debugCode: this.debugCode});

					this.state = 'idle';

					this.hide();

				}

			},
			chooseReleaseType(type) {

				this.releaseType = type;

				this.collectData();

				Broadcast.call("Pseudo Modal Hide", ['release-type-dropdown']);

			},
			copy() {

				let text = '';

				if (this.result) {
					if (this.result.type === 'tag') text = this.result.data;
					else if (this.result.type === 'file-link') text = (Publisher.SelectedPublisher.options['AmazonS3']['cdnUrl'] || ('https://' + Publisher.SelectedPublisher.options['AmazonS3']['bucketName'] + '.s3.' + this.region + '.amazonaws.com/')) + this.creativeFolder + '/' + this.versionFolder + '/' + this.result.data;
				}

				Layout.copyTextToClipboard(text);

			},
			close() {

				this.state = 'idle';

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.upload-sky-kids
		position: absolute
		z-index: 200
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 600px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.col-form-label
				display: flex
				flex-direction: row
				line-height: 32px
				width: 50%
				justify-content: space-between

				.title
					display: flex
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap
					flex-direction: row
					align-items: baseline

					.icon-info
						color: #20a8d8
						margin-left: 5px
						font-size: 13px !important

				.switch
					margin-top: 6px

				.switch-slider
					background-color: #343b41
					border: 1px solid #23282c

				.custom-select
					cursor: pointer
					color: #fff
					width: auto
					background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
					background-color: #343b41
					border: 1px solid #23282c
					margin-top: 0

					&.selected
						background-color: #4dbd74

				.custom-select[multiple]
					background: #343b41
					height: calc(100% - 14px)
					margin-top: 7px

			.col-form-label:first-child
				margin-right: 20px

			.col-form-label.column
				flex-direction: column

				.col-form-label
					width: 100%

			input
				width: 50%

			input[type="date"]
				font-size: 13px
				padding: 3px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.form-control.release-type
				cursor: pointer
				//width: 150px
				margin-top: 5px
				user-select: none
				white-space: nowrap

			.input-group-append
				margin-top: 5px
				cursor: pointer

				.input-group-text
					background-color: #343b41
					border: 1px solid #23282c
					color: #e4e7ea

		.two-setting-panel
			display: flex
			flex-direction: row
			justify-content: space-between

			.setting-one

				.form-control.region
					width: 200px

		.form-result
			color: #20a8d8
			font-size: 11px

		.processing
			height: 100%
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center

			.icon
				display: inline
				font-size: 30px

		.result

			textarea
				width: 100%
				height: 250px
				background: transparent
				border: none
				color: #fff
				font-size: 12px
				white-space: pre
				overflow-wrap: normal
				overflow-x: auto
</style>

